<template>
  <div class="wrapper__table">
    <table class="container__table"
      v-if="solicitacoes.length > 0"
    >
      <thead class="container__table-head">
        <tr>
          <th>#</th>
          <th>Paciente</th>
          <th>Tutor</th>
          <th>Data</th>
          <th>Status</th>
          <th>Ação</th>
        </tr>
      </thead>
      <tbody class="container__table-body">
        <tr
          v-for="(solicitacao, i) in solicitacoes" :key="solicitacao.ID_SOLICITACAO"
        >
          <td data-label="#">{{ solicitacao.ID_SOLICITACAO }}</td>
          <td data-label="Paciente">{{ solicitacao.PACIENTE }}</td>
          <td data-label="Tutor">{{ solicitacao.NOME_TUTOR }}</td>
          <td data-label="Data">{{ solicitacao.DT_SOLICITACAO }}</td>
          <td data-label="Status">
            <select name="status" id="status__select" @change="$emit('alterarStatus', {idSolicitacao: solicitacao.ID_SOLICITACAO, novoStatus: $event.target.value})">
              <option :selected="solicitacao.STATUS_SOLICITACAO === 'FINALIZADO'" value="FINALIZADO">FINALIZADO</option>
              <option :selected="solicitacao.STATUS_SOLICITACAO === 'AGUARDO DE ANALISE'" value="AGUARDO DE ANALISE">AGUARDO DE ANALISE</option>
              <option :selected="solicitacao.STATUS_SOLICITACAO === 'PROCESSANDO'" value="PROCESSANDO">PROCESSANDO</option>
              <option :selected="solicitacao.STATUS_SOLICITACAO === 'CANCELADO'" value="CANCELADO">CANCELADO</option>
            </select>
          </td>
          <td data-label="Ação">
            <button
              @click="
                $emit('update:solicitacao', i);
                $emit('abrir');
              "
            >
              <img src="@/assets/images/searchIcon.svg" alt="Lupa" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <h1
      v-else
    >
    Não há solicitações cadastrados
    </h1>
  </div>
</template>

<script>
export default {
  name: 'TabelaSolicitacoes',
  props: ['solicitacoes']
}
</script>

<style scoped>
h1 {
  text-align: center;
  color: var(--primary-color);
  width: 100%;
}
.wrapper__table {
  width: 420px;
  max-width: 70%;
  max-height: 100%;
  overflow-y: auto;
}
.container__table {
  width: 100%;
}

.container__table-head {
  display: none;
}

.container__table-body tr {
  border: 1px solid #dad6eb;
  border-radius: 5px;
  display: block;
  padding: 30px;
  margin-bottom: 30px;
}

.container__table-body tr td {
  display: block;
  padding: 5px;
  position: relative;
  text-align: right;
}

.container__table-body tr td button {
  background: var(--primary-color);
  border: none;
  border-radius: 20px;
  box-shadow: 0 4px 8px rgba(34, 34, 34, 0.2);
  bottom: -30px;
  color: #fff;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  left: 50%;
  padding: 10px 0;
  position: absolute;
  transform: translate(-50%, 50%);
  transition: all 0.12s ease-out;
  width: 50%;
}

.container__table-body tr td button:hover,
.container__table-body tr td button:focus {
  background: var(--primary-light-color);
  cursor: pointer;
}

.container__table-body tr td button img {
  width: 20px;
  height: 20px;
}

.container__table-body tr td:before {
  color: #8a8a87;
  content: attr(data-label);
  font-weight: 400;
  left: 5px;
  position: absolute;
}

#status__select{
    outline: none;
    height: 20px;
    border: none;
    border-radius: 10px;
    background-color:var(--primary-color);
    color: #fff;
    text-align: center;
    font-size: 10px;
  }
  #status__select option{
    background-color: var(--primary-light-color);
  }

@media all and (max-width: 425px) {
  .header__titles-ul li a {
    font-size: 15px;
  }

  .container__table-body tr td {
    font-size: 10px;
  }

  .container__table-body tr td button {
    width: 50px;
    height: 35px;
  }

  #status__select{
    outline: none;
    width: 90px;
    height: 20px;
    border: none;
    border-radius: 10px;
    background-color:var(--primary-color);
    color: #fff;
    text-align: center;
    font-size: 10px;
  }
  #status__select option{
    background-color: var(--primary-light-color);
  }
}

/* media query */
@media all and (min-width: 850px) {
  .wrapper__table {
    min-width: 850px;
  }

  .header__titles {
    justify-content: flex-end;
  }

  .container__table-head {
    display: table-header-group;
  }

  .container__table-head th {
    width: 250px;
    height: 40px;
    border-radius: 10px;
    text-align: center;
    color: var(--light-color);
    background: var(--primary-color);
  }

  .container__table-head th:last-child {
    width: 100px;
  }

  .container__table-body {
    font-size: 1em;
  }

  .container__table-body tr {
    display: table-row;
  }

  .container__table-body tr td {
    display: table-cell;
    padding: 10px;
    text-align: center;
  }

  .container__table-body tr td .status {
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    padding-top: 5px;
    border-radius: 10px;
    font-weight: bold;
    color: var(--light-color);
    text-align: center;
  }
  .container__table-body tr td button {
    display: inline-block;
    position: initial;
    transform: translate(0);
    width: 80px;
  }

  .container__table-body tr td:before {
    display: none;
  }

  #status__select{
    outline: none;
    height: 30px;
    border: none;
    border-radius: 10px;
    background-color:var(--primary-color);
    color: #fff;
    text-align: center;
  }
  #status__select option{
    background-color: var(--primary-light-color);
  }
}
</style>
